
import React, { useEffect } from 'react';
import { Navbar } from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';
import ReferralOpportunityHero from '@/components/homepage/referral/ReferralOpportunityHero';
import ResidualIncomeCalculator from '@/components/homepage/referral/ResidualIncomeCalculator';



const ReferralOpportunity: React.FC = () => {

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-gray-900">
      <Navbar />
      <main>
        <ReferralOpportunityHero />
        {/* <ResidualIncomeCalculator /> */}
      </main>
      <Footer />
    </div>
  );
};

export default ReferralOpportunity;
